module.exports = __webpack_public_path__ + "static/media/nuru1.65996471.png";